import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchAllDashboardsAPI } from "src/services/AccountDashboardAPIs";
import { getApiLangFromI18n } from "src/utils/apiLang";
import { buildUserAccessibleDashboardsFromApi } from "../Config/DashboardRoutes";
import type { SidebarItem } from "../Config/SidebarConfig";

/** Dashboards assigned to the current user, mapped to sidebar/search items. */
export const useDashboardSidebarItems = (): SidebarItem[] => {
  const { i18n } = useTranslation();
  const [dashboardItems, setDashboardItems] = useState<SidebarItem[]>([]);

  useEffect(() => {
    let mounted = true;

    const loadDashboardItems = async () => {
      const userId = localStorage.getItem("user_id");
      const apiKey = localStorage.getItem("api_key");

      if (!userId || !apiKey) {
        if (mounted) {
          setDashboardItems([]);
        }
        return;
      }

      try {
        const dashboards = await fetchAllDashboardsAPI(userId, apiKey, getApiLangFromI18n(i18n));
        if (!mounted) {
          return;
        }

        setDashboardItems(
          buildUserAccessibleDashboardsFromApi(dashboards).map(dashboard => ({
            name: dashboard.dashboardName,
            route: dashboard.route,
          }))
        );
      } catch {
        if (mounted) {
          setDashboardItems([]);
        }
      }
    };

    loadDashboardItems();

    return () => {
      mounted = false;
    };
  }, [i18n, i18n.language, i18n.resolvedLanguage]);

  return dashboardItems;
};
